// src/components/ErrorPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import './ErrorPage.css'; // Importing the custom CSS file

const ErrorPage = () => {
  return (
    <div className="error-page">
      <div className="error-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-message">Oops! The page you're looking for doesn't exist.</h2>
        <p className="error-description">
          It seems like you got lost in the vast world of the internet.
        </p>
        <Link to="/" className="home-button">
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
